/**
 * A type guard that checks if an element is in an array.
 */
export function isElementOf(array, element) {
  return array.includes(element);
}